(() => {
  const MOBILE_QUERY = '(max-width: 749px)';

  function pushEvent(event, detail = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
  }

  function initialiseWall(root) {
    if (root.dataset.fwCommunityReady === 'true') return;

    const grid = root.querySelector('[data-fw-community-grid]');
    const items = [...root.querySelectorAll('[data-fw-community-item]')];
    const moreButton = root.querySelector('[data-fw-community-more]');
    const moreLabel = root.querySelector('[data-fw-community-more-label]');
    const mobileQuery = window.matchMedia(MOBILE_QUERY);

    if (!grid || items.length === 0) return;
    root.dataset.fwCommunityReady = 'true';

    let frame = 0;

    const measure = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (mobileQuery.matches || grid.classList.contains('fw-community__grid--short')) {
          items.forEach((item) => {
            item.style.gridRowEnd = '';
          });
          return;
        }

        const styles = window.getComputedStyle(grid);
        const rowHeight = Number.parseFloat(styles.gridAutoRows);
        const rowGap = Number.parseFloat(styles.rowGap);

        items.forEach((item) => {
          if (window.getComputedStyle(item).display === 'none') return;
          const content = item.firstElementChild;
          if (!content) return;
          const height = content.getBoundingClientRect().height;
          const span = Math.ceil((height + rowGap) / (rowHeight + rowGap));
          const nextValue = `span ${span}`;
          if (item.style.gridRowEnd !== nextValue) item.style.gridRowEnd = nextValue;
        });
      });
    };

    root.classList.add('is-ready');

    if (moreButton && moreLabel) {
      moreButton.hidden = false;
      moreButton.addEventListener('click', () => {
        const expanded = root.classList.toggle('is-expanded');
        moreButton.setAttribute('aria-expanded', String(expanded));
        moreLabel.textContent = expanded ? 'View Less' : 'View More';
        pushEvent('community_wall_expand', {
          expanded,
          visible_image_count: expanded ? items.length : Math.min(items.length, 8),
          total_image_count: items.length,
        });
        measure();
      });
    }

    grid.addEventListener('click', (event) => {
      const link = event.target.closest('.fw-community__link');
      if (!link) return;
      const item = link.closest('[data-fw-community-item]');
      pushEvent('community_wall_product_click', {
        block_index: Number(item.dataset.index),
        product_handle: item.dataset.productHandle || '',
        movement_context: item.dataset.movementContext || '',
        source_type: item.dataset.sourceType || '',
        layout_role: item.dataset.layoutRole || '',
      });
    });

    const recordView = () => {
      pushEvent('community_wall_view', {
        visible_image_count: mobileQuery.matches ? items.length : Math.min(items.length, 8),
        total_image_count: items.length,
        section_position: root.dataset.sectionPosition || 'unknown',
      });
    };

    if ('IntersectionObserver' in window) {
      const viewObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        recordView();
        observer.disconnect();
      }, { threshold: 0.25 });
      viewObserver.observe(root);
    } else {
      recordView();
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(grid);
      items.forEach((item) => {
        if (item.firstElementChild) resizeObserver.observe(item.firstElementChild);
      });
    } else {
      window.addEventListener('resize', measure, { passive: true });
    }

    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', measure);
    else mobileQuery.addListener(measure);
    measure();
  }

  function initialiseAll() {
    document.querySelectorAll('[data-fw-community]').forEach(initialiseWall);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
